import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { formatConfigTimeToTime } from '../../../libs/dateUtilities';
import { getNumberOfDaysBreakPoint } from '../../../libs/calendarConfig';
import SmallSemiTruckIcon from '../../../images/calendar/smallSemiTruckIcon.js';
import clsx from 'classnames';
import _ from 'lodash';
import ShiftFlags from './ShiftFlags';

function styles() {
	return {
		shiftContainer: {
			backgroundColor: '#665', //-overridden
			color: '#fff', //- overridden
			fontWeight: 500,
			fontSize: 14,
			display: 'flex',
			margin: `2px 2px`,
			padding: `11px 7px`,
			borderRadius: 1,

			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			position: 'relative',
		},
		shiftTruckContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'left',
			alignItems: 'center',
		},
		shiftStart: {
			marginRight: 6,
			borderRight: '1px solid rgba(255,255,255,.7)',
			paddingRight: 6,
		},
		open: {
			fontWeight: 500,
		},
		openVertical: {
			fontWeight: 500,
			writingMode: 'vertical-rl',
			textOrientation: 'mixed',
			marginTop: -5,
			marginRight: -5,
			marginBottom: -5,
			fontSize: 10,
		},
		whiteSemiTruckIcon: {
			display: 'inline-block',
			width: 15,
			height: 15,
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 0,
		},
		truckInfo: {
			display: 'flex',
			fontWeight: 600,
			alignItems: 'center',
		},
		markerTop: {
			position: 'absolute',
			top: 0,
			right: 0,
			borderColor: 'transparent',
			borderStyle: 'solid',
		},
		markerBottom: {
			position: 'absolute',
			top: 0,
			right: 0,
			borderColor: 'transparent',
			borderStyle: 'solid',
			borderRadius: '1px',
		},
		noteTop: {
			borderWidth: '8.5px',
			borderRightColor: '#fff',
			borderTopColor: '#fff',
			zIndex: 4,
		},
		noteBottom: {
			borderWidth: '8px',
			borderRightColor: '#00BCD4',
			borderTopColor: '#00BCD4',
			zIndex: 4,
		},
		overrideTop: {
			top: 'auto',
			bottom: 0,
			borderWidth: '8.5px',
			borderRightColor: '#fff',
			borderBottomColor: '#fff',
		},
		overrideBottom: {
			top: 'auto',
			bottom: 0,
			borderWidth: '8px',
			borderRightColor: '#FF5722',
			borderBottomColor: '#FF5722',
		},
		showManufacturer: {
			display: 'flex',
			flexDirection: 'column',
			position: 'absolute',
			bottom: 0,
			margin: 1,
			zIndex: 5,
			fontSize: 12,
			fontWeight: 500,
			textTransform: 'uppercase',
			textAlign: 'left',
			paddingLeft: 10,
			left: 0,
			paddingBottom: 2,
		},
		showManufacturerNodIsMedium: {
			fontSize: 10,
		},
		showManufacturerNodIsLarge: {
			fontSize: 8,
		},
	};
}

function Shift(props) {
	const {
		numberOfDays,
		equipment,
		user,
		shiftTime,
		style,
		id,
		isOpen,
		classes,
		hasNotes,
		hasOverrides,
		equipmentStatus,
		showManufacturer,
		hideShiftTime,
	} = props;

	const { nodIsSmall, nodIsMedium, nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);

	//- For a ton of days dont' show the truck or the driver
	let time = '';
	if (!nodIsLarge) {
		time = <div className={classes.shiftStart}>{formatConfigTimeToTime(shiftTime)}</div>;
	}

	let details = '';
	let manufacturerName = '';
	let showManufacturerNodClass = null;
	if (equipment) {
		details = (
			<div className={classes.truckInfo}>
				{nodIsSmall && (
					<SmallSemiTruckIcon fill={style.color} className={classes.whiteSemiTruckIcon} />
				)}
				<div>{equipment.display}</div>
			</div>
		);

		/** @namespace eqiupment.make **/
		manufacturerName = equipment.make || 'missing';
		if (nodIsLarge) {
			manufacturerName = manufacturerName.substring(0, 4);
			showManufacturerNodClass = classes.showManufacturerNodIsLarge;
		} else if (nodIsMedium) {
			showManufacturerNodClass = classes.showManufacturerNodIsMedium;
		}
	} else if (user) {
		let userName = '';
		if (user.firstName) {
			userName = user.firstName.charAt(0);
		}

		if (nodIsSmall) {
			userName += ` ${user.lastName}`;
		} else {
			if (_.isString(user.lastName)) {
				userName += `${user.lastName.substring(0, 4)}`;
			}
		}

		details = (
			<div className={classes.truckInfo}>
				<div>{userName}</div>
			</div>
		);
	}

	let truckStyle = {};
	if (showManufacturer) {
		truckStyle.position = 'relative';
		truckStyle.top = nodIsLarge ? -2 : -5;
	}

	return (
		<div key={id} className={classes.shiftContainer} style={style}>
			<div className={classes.shiftTruckContainer} style={truckStyle}>
				{!hideShiftTime && time}
				{details}
			</div>

			{isOpen && !nodIsLarge && <div className={classes.openVertical}>OPEN</div>}

			{hasNotes && (
				<Fragment>
					<div className={clsx(classes.markerTop, classes.noteTop)} />
					<div className={clsx(classes.markerBottom, classes.noteBottom)} />
				</Fragment>
			)}

			{hasOverrides && (
				<Fragment>
					<div className={clsx(classes.markerTop, classes.overrideTop)} />
					<div className={clsx(classes.markerBottom, classes.overrideBottom)} />
				</Fragment>
			)}

			<ShiftFlags numberOfDays={numberOfDays} equipmentStatus={equipmentStatus} />

			{showManufacturer && (
				<div className={clsx(classes.showManufacturer, showManufacturerNodClass)}>
					{manufacturerName}
				</div>
			)}
		</div>
	);
}
Shift.propTypes = {
	numberOfDays: PropTypes.number,
};
Shift.defaultProps = {};
export default withStyles(styles)(Shift);
